import { NextSeo } from 'next-seo';

//screen
import { ExpeditedShipping } from '/screens/';

export default function ExpeditedShippingPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        canonical="https://loadsmart.com/shipper/expedited-shipping/"
        openGraph={{
          url: 'https://loadsmart.com/shipper/expedited-shipping/',
        }}
        title="Expedited Shipping"
        description="Looking for expedited shipping solutions? Loadsmart has you covered. Our dedicated support teams, advanced technology, and experienced drivers ensure top-notch service. Experience fast and reliable delivery with Loadsmart Expedited Shipping."
      />
      <ExpeditedShipping />
    </>
  );
}
